import { render, staticRenderFns } from "./NotFoundComponent.vue?vue&type=template&id=83eff5fa&scoped=true&"
var script = {}
import style0 from "./NotFoundComponent.vue?vue&type=style&index=0&id=83eff5fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83eff5fa",
  null
  
)

export default component.exports